import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs';
import { SysNonceTypes } from '../models/sys-nonce-type.enum';
import { AuthService } from '../services/auth.service';
import { PortalSelectionService } from '../services/portal-selection.service';

@Injectable({
  providedIn: 'root',
})
export class LoginByNonceGuardService implements CanActivate {
  constructor(
    private auth: AuthService,
    private router: Router,
    private portalSelectionService: PortalSelectionService
  ) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> {
    const nonceId = route.paramMap.get('nonceId');

    if (!nonceId) {
      return of(true);
    }

    return new Observable<boolean | UrlTree>(observer => {
      this.auth.loginUserByNonceId(nonceId).subscribe({
        next: res => {
          if (res.usernameTiedToNonce && res.id) {
            this.portalSelectionService
              .handlePortalSelection(res.id, res.usernameTiedToNonce)
              .subscribe(() => {
                observer.next(true);
                observer.complete();
              });
            return;
          }

          const userTypeId = +res.sysExternalWebUserTypeId;
          const nonceTypeId = res.sysNonceTypeId;

          if (userTypeId) {
            const isReadOnly =
              nonceTypeId === SysNonceTypes.ImpersonateClient ||
              nonceTypeId === SysNonceTypes.ImpersonateASF;
            this.portalSelectionService.completeLogin(res, isReadOnly);
            observer.next(true);
          }
          observer.complete();
        },
        error: () => {
          observer.next(this.router.parseUrl('/login'));
          observer.complete();
        },
      });
    });
  }
}
